module.exports = __webpack_public_path__ + "static/img/zhuanjia.2171d06e.png";